export default __webpack_public_path__ + "static/media/step_G_2_UA.2cdf6236.png";